module.exports = ".warning-mail-editor-fields {\n  color: #ec4758;\n  display: block;\n  text-align: left;\n  margin-left: 15px; }\n\n.template-editor-scroll {\n  overflow-y: hidden;\n  border: 1px solid #e5e6e7;\n  border-radius: 4px;\n  padding: 10px; }\n\n:host ::ng-deep .editor {\n  min-height: 250px !important;\n  max-height: 250px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/email/campaigns/edit-campaign-content/edit-campaign-content.component.scss
// module id = ./src/app/modules/email/campaigns/edit-campaign-content/edit-campaign-content.component.scss
// module chunks = main